import React, { useRef, useEffect } from "react"
import { gsap } from "gsap"
import Link from "reactor/components/Link"
import BoxItem from 'reactor/components/Box'

import {
    staggerText,
    staggerReveal,
    fadeInUp,
    handleHover,
    handleHoverExit,
    // handleCityReturn,
    // handleCity,
    staggerRevealClose
} from "./Animations";

// import dallas from "assets/images/dallas.webp";
// import austin from "assets/images/austin.webp";

// const cities = [
//   { name: "Dallas", image: dallas },
//   { name: "Austin", image: austin }
// ];


const NavLinksFirstLayer = [
    {
        title: 'عن رواد',
        href: '/',
        children: [
            {
                title: "من نحن",
                href: "/"
            },
            {
                title: "اتفاقية الخدمة",
                href: "/"
            },
            {
                title: "سياسة الخصوصية ",
                href: "/"
            },
            {
                title: "طرق الدفع والحسابات",
                href: "/rowaad-payments"
            }
        ]
    },
    {
        title: 'خدماتنا',
        href: '/',
        children: [
            {
                title: "تصميم تطبيقات الجوال",
                href: "/"
            },
            {
                title: "تصميم متجر الكتروني",
                hrefOut: "https://products.rh.net.sa/store/web/"
            },
            {
                title: "تطبيق متجر الكتروني",
                hrefOut: "https://products.rh.net.sa/store/app/"
            },
            {
                title: "تصميم المواقع الإلكترونية",
                href: "/"
            },
            {
                title: "تصميم اكاديمية عن بعد",
                href: "/"
            },
            {
                title: "تصميم الشعارات والهويات",
                href: "/"
            },
            {
                title: "إستضافة مشتركة",
                href: "/"
            },
            {
                title: "خوادم كاملة",
                href: "/"
            },
            {
                title: "خوادم مشتركة",
                href: "/"
            }
        ]
    },
    {
        title: 'منتجاتنا',
        href:'/',
        children: [
            {
                title: "متجر إلكتروني",
                hrefOut: "https://products.rh.net.sa/store/web/"
            },
            {
                title: "تطبيق إلكتروني",
                hrefOut: "https://products.rh.net.sa/store/app/"
            },
            {
                title: "قريبا تطبيق لحجز المواعيد",
                href: "#"
            }
        ]
    },
    {
        title: 'أعمالنا',
        href: '/templates'
    },
    {
        title: 'المدونة',
        href: '/'
    },
    {
        title: 'اتصل بنا',
        href: '/contact-us'
    },
];

const NavLinksHelp = [
    {
        title: 'تسجيل الدخول',
        href: 'https://my.rh.net.sa/index.php?rp=/login'
    },
    {
        title: 'فتح التدكرة',
        href: 'https://my.rh.net.sa/submitticket.php?step=2&deptid=26'
    },
];

export default function Hamburger({ state }) {
    // Create varibles of our dom nodes
    let menuLayer = useRef(null);
    let reveal1 = useRef(null);
    let reveal2 = useRef(null);
    // let cityBackground = useRef(null);
    //   let line1 = useRef(null);
    let info = useRef(null);
    const line1 = useRef(Array.from({length: NavLinksFirstLayer.length}, () => React.createRef()));

  useEffect(() => {
    // If the menu is open and we click the menu button to close it.
    if (state.clicked === false) {
      // If menu is closed and we want to open it.

      staggerRevealClose(reveal2, reveal1);
      // Set menu to display none
      gsap.to(menuLayer, { duration: 1, css: { display: "none" } });
    } else if (
      state.clicked === true ||
      (state.clicked === true && state.initial === null)
    ) {
        // Set menu to display block
        gsap.to(menuLayer, { duration: 0, css: { display: "block" } });
        //Allow menu to have height of 100%
        gsap.to([reveal1, reveal2], {
        duration: 0,
        opacity: 1,
        height: "100%"
        });
        staggerReveal(reveal1, reveal2);
        staggerText(line1);
    }
  }, [state]);


  return (
    <div ref={el => (menuLayer = el)} className='hamburger-menu'>
        <div
            ref={el => (reveal1 = el)}
            className='menu-secondary-background-color'></div>
        <div ref={el => (reveal2 = el)} className='menu-layer'>
        <div
            // ref={el => (cityBackground = el)}
            className='menu-city-background'></div>
        <div className='container'>
            <div className='wrapper'>
                <div className='menu-links'>
                    <nav>
                        <div className="menu__shape"></div>
                        <ul>
                            { NavLinksFirstLayer.map( (link, index) => (
                            <li key={"item" + index}>
                                { link.hrefOut ? <a href={link.hrefOut} target="_blank" rel="noopener">{link.title}</a> : <Link to={link.href} className="nav-link">{link.title}</Link>}
                                    {link.children && (
                                    <div className='dropdown-wrapper'>
                                        <ul className="dropdown-menu list-unstyled">
                                            {link.children.map((link, index) => (
                                                <li key={"subitem" + index}> { link.hrefOut ? <a href={link.hrefOut} target="_blank" rel="noopener">{link.title}</a> : <Link to ={link.href} key={index}>{link.title}</Link> } </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </li>
                            ))}
                        </ul>
                        <ul className="list-unstyled">
                            { NavLinksHelp.map( (link, index) => (
                                <li key={index}>
                                    <Link className="menuLink" href={link.href}>{link.title}
                                        <BoxItem component="span" display="block">{link.subtitle}</BoxItem>
                                    </Link>
                                </li>
                            )) }
                        </ul>
                    </nav>git
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};
